import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickSearchProductsPickedProductsButton from "./PathPickSearchProductsPickedProductsButton";
import useGetPathPickCounts from "@/features/pathpick/hooks/query/useGetPathPickCounts";

function PathPickSearchProductsHeader() {
  const { tTitle, tSentence } = useI18nHelper();
  const navigate = useNavigate();
  // 개수 전용 API — 상품 목록으로 개수만 얻으면 두 소스 조회·크림 조인까지 다 돌아 느리다.

  return (
    <Flex justifyContent={"space-between"} alignItems={"center"}>
      <Flex flexDirection={"column"} gap={"2px"}>
        <Text textStyle={"body-lg-bold"}>
          {tTitle("path_pick:search_products.title")}
        </Text>
        <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
          {tSentence("path_pick:search_products.description")}
        </Text>
      </Flex>
      {/*<PathPickSearchProductsPickedProductsButton*/}
      {/*  count={pathPickCounts?.basket.totalCount ?? 0}*/}
      {/*  onClick={() => navigate("/pathpick/basket")}*/}
      {/*/>*/}
    </Flex>
  );
}

export default PathPickSearchProductsHeader;
